import { createFileRoute } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { Offcanvas } from '@/entities/offcanvas'
import { CreateCompanyForm } from '@/features/company'
import { useRouteOffcanvas } from '@/shared/hooks/use-route-offcanvas'

export const Route = createFileRoute('/_auth/administration/reference-books/company/create')({
  component: RouteComponent,
})

function RouteComponent() {
  const { isOpen, close } = useRouteOffcanvas()
  const { t } = useTranslation()

  return (
    <Offcanvas open={isOpen} onClose={close} title={t('Создать организацию')}>
      <CreateCompanyForm onClose={close} />
    </Offcanvas>
  )
}
